import { applyMiddleware, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import rootReducer from '../reducers';

/*var composeEnhancers: any = '';

if (process.env.NODE_ENV === 'development') {
    composeEnhancers =  window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
}*/

export default function configureStore() {
    return createStore(
        rootReducer,
        applyMiddleware(reduxThunk)
    );
}


// WEBPACK FOOTER //
// ./src/stores/index.tsx